<!-- <button mat-button (click)="onClose()">Exit</button>
<div class="camera-container"> -->
<app-camera></app-camera>
<!-- <app-web-camera></app-web-camera> -->
<!-- </div> -->
